import { useAtomValue } from "jotai";
import { useNavigate, useSearchParams } from "react-router-dom";
import { userInfoAtom } from "../../atoms";
import FullPageMessage from "../../components/FullPageMessage/FullPageMessage";

function TikTokPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Jotai State
  const userInfo = useAtomValue(userInfoAtom);

  const success = searchParams.get("success");
  const errorMessage = searchParams.get("errorMessage");
  const userNotFound = searchParams.get("userNotFound");

  const handleNavigate = () => {
    navigate(`/profile/${userInfo?.brandId ?? userInfo?.email}`);
  };

  if (userNotFound === "true") {
    return (
      <FullPageMessage
        type="info"
        title="TikTok Account Linked!"
        message="Your TikTok account has been successfully linked! However, you haven't quite earned enough TikTok Shop commission yet to track Shop stats. Don't worry - once you cross that threshold, we'll automatically update your profile with your Shop data."
        actionButton={{
          label: "Go to Profile",
          onClick: handleNavigate,
        }}
      />
    );
  }

  if (success === "true") {
    return (
      <FullPageMessage
        type="info"
        title="Success!"
        message="You should now see your TikTok data in your profile and displayed to brands!"
        actionButton={{
          label: "Go to Profile",
          onClick: handleNavigate,
        }}
      />
    );
  }

  if (errorMessage) {
    return (
      <FullPageMessage
        type="error"
        title="Something went wrong"
        message={errorMessage}
        actionButton={{
          label: "Go to Profile",
          onClick: handleNavigate,
        }}
      />
    );
  }

  return (
    <FullPageMessage
      type="warning"
      title="No status message"
      message="No success or error message was provided."
      actionButton={{
        label: "Go to Profile",
        onClick: handleNavigate,
      }}
    />
  );
}

export default TikTokPage;
